import Vue from 'vue'
import VueRouter from 'vue-router'

if (process.env.NODE_ENV === 'development') {
    Vue.use(VueRouter)
}

import {
    ROUTER_MODE
} from '../config/app'

import Home from '../views/home/index.vue'
// 管理组相关
import adminRouter from '../views/userManage/admin/router.vue'
import authAdmin from '../views/userManage/admin/authAdmin.vue'
import accountTransfer from '../views/userManage/admin/accountTransfer.vue'
import authRole from '../views/userManage/admin/authRole.vue'
import authPermissionRule from '../views/userManage/admin/authPermissionRule.vue'
// 上传相关
// import tinymce from "../views/components/tinymce-demo.vue";
// import upload from "../views/components/upload-demo.vue";

Vue.use(VueRouter)

const err401 = r =>
    require.ensure([], () => r(require('../views/error/err401.vue')), 'home')
const err404 = r =>
    require.ensure([], () => r(require('../views/error/err404.vue')), 'home')
const login = r =>
    require.ensure([], () => r(require('../views/login/index.vue')), 'home')
const setting = r =>
    require.ensure([], () => r(require('../views/login/setting.vue')), 'home')
const agent = r =>
    require.ensure([], () => r(require('../views/login/agent.vue')), 'home')
const main = r =>
    require.ensure([], () => r(require('../views/home/main.vue')), 'home')

// 注意 权限字段 authRule （严格区分大小写）
export const constantRouterMap = [{
    path: '*',
    component: err404,
    hidden: true
},
    {
        path: '/401',
        component: err401,
        name: '401',
        hidden: true
    },
    {
        path: '/404',
        component: err404,
        name: '404',
        hidden: true
    },
    {
        path: '/500',
        component: err404,
        name: '500',
        hidden: true
    },
    {
        path: '/setting',
        component: setting,
        name: '确认用户信息',
        hidden: true
    },
    {
        path: '/login',
        component: login,
        name: '登录',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        redirect: '/readme',
        name: '',
        hidden: true
    },
    {
        path: '/readme',
        component: Home,
        icon: 'shouye',
        redirect: '/readme/main',
        name: '首页',
        noDropdown: true,
        children: [{
            path: 'main',
            component: main
        }]
    },
    {
        path: '/personal',
        component: Home,
        name: '个人中心',
        hidden: true,
        children: [{
            path: 'personal',
            component: () => import('@/views/personal/personal.vue')
        }]
    },
    {
        path: '/agent',
        component: agent,
        name: '注册用户',
        hidden: true
    }
]

const createRouter = () =>
    new VueRouter({
        // mode: 'history', //后端支持可开
        mode: ROUTER_MODE,
        routes: constantRouterMap,
        strict: process.env.NODE_ENV !== 'production'
    })
const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export const asyncRouterMap = [
    {
        path: '/userList',
        component: Home,
        redirect: '/userList/user',
        icon: 'user',
        name: '用户列表',
        meta: {
            authRule: ['admin/user/manager/users']
        },
        noDropdown: true,
        children: [{
            path: 'user',
            name: '用户详情',
            component: () => import('@/views/users/users.vue')
        },
            {
                path: 'rechargerecord',
                name: '充值记录',
                component: () => import('@/views/users/rechargerecord.vue')
            }
        ]
    },
    {
        path: '/userManage',
        redirect: '/userManage/adminManage/index',
        component: Home,
        icon: 'guanliyuan1',
        name: '系统管理',
        meta: {
            authRule: ['user_manage']
        },
        children: [{
            path: '/userManage/adminManage',
            component: adminRouter,
            redirect: '/userManage/authAdmin/index',
            name: '权限管理',
            icon: '',
            meta: {
                authRule: ['user_manage/admin_manage']
            },
            children: [
                {
                    path: 'authAdmin',
                    component: authAdmin,
                    name: '用户管理',
                    icon: '',
                    meta: {
                        authRule: ['admin/auth/admin/index']
                    }
                },
                {
                    path: 'groupManagement',
                    component: () => import('@/views/groupManagement/index.vue'),
                    name: '组长管理',
                    icon: '',
                    meta: {
                        authRule: ['admin/group/manager/ui']
                    }
                },
                {
                    path: 'accountTransfer',
                    component: accountTransfer,
                    name: '账号转移',
                    icon: '',
                    meta: {
                        authRule: ['admin/manager_transfer']
                    }
                },
                {
                    path: 'authRole',
                    component: authRole,
                    name: '角色管理',
                    icon: '',
                    meta: {
                        authRule: ['admin/auth/role/index']
                    }
                },
                {
                    path: 'authPermissionRule',
                    component: authPermissionRule,
                    name: '菜单管理',
                    icon: '',
                    meta: {
                        authRule: ['admin/auth/permission_rule/index']
                    }
                },
                {
                    path: 'configuration',
                    component: () => import('@/views/userManage/admin/configuration.vue'),
                    name: '配置',
                    icon: '',
                    meta: {
                        authRule: ['config']
                    }
                },
            ]
        }]
    },
    {
        path: '/categoryList',
        component: Home,
        redirect: '/categoryList/index',
        icon: 'wxbzhanghu',
        name: '类目',
        meta: {
            authRule: ['admin/manager/index/get_category_list']
        },
        children: [{
            path: 'index',
            name: '类目列表',
            component: () => import('@/views/categoryList/index.vue')
        },
        {
            path: 'map',
            name: '类目映射',
            component: () => import('@/views/categoryList/map.vue')
        }]
    },
    {
        path: '/statistics',
        component: Home,
        name: '数据统计',
        hidden: true,
        children: [{
            path: 'index',
            component: () => import('@/views/statistics/index.vue')
        }]
    },
    {
        path: '/etymaPhp',
        component: Home,
        redirect: '/etymaPhp/index',
        icon: 'etyma',
        name: '种子词库',
        meta: {
            authRule: ['selection_seed_word']
        },
        noDropdown: false,
        children: [
            {
                // 普通用户列表
                path: 'index',
                name: 'Asin列表',
                component: () => import('@/views/etymaPhp/index.vue'),
                meta: {
                    authRule: ['admin/seed_word/asin_list/operator_lists']
                }
            },
            {
                // admin列表
                path: 'index',
                name: 'Asin列表',
                component: () => import('@/views/etymaPhp/adminIndex.vue'),
                meta: {
                    authRule: ['admin/seed_word/asin_list/manager_lists']
                }
            }
        ]
    },
    {
        path: '/lowPriceMall',
        component: Home,
        redirect: '/lowPriceMall/index',
        icon: 'wxbzhanghu',
        name: '低价商城',
        meta: {
            authRule: ['low_price_mall']
        },
        noDropdown: false,
        children: [
            {
                path: '/lowPriceMall/analyse',
                name: '竞品分析',
                meta: {
                    authRule: ['low_price_mall/manager_low_price_mall_cost_analysis']
                },
                noDropdown: false,
                component: adminRouter,
                children:[
                    {
                        path: 'index',
                        name: '选品列表统计',
                        component: () => import('@/views/lowPriceMall/index.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_manager_analysis_list']
                        }
                    },
                    {
                        path: 'inPurchasingLowPrice',
                        name: '采购中列表统计',
                        component: () => import('@/views/lowPriceMall/inPurchasingLowPrice.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_manager_purchase_list']
                        }
                    },
                    {
                        path: 'purchaseCompletedLowPrice',
                        name: '采购完成列表统计',
                        component: () => import('@/views/lowPriceMall/purchaseCompletedLowPrice.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_manager_purchase_finish_list']
                        }
                    },
                ]
            },
            // 采购-选品
            {
                path: '/lowPriceMall/selection',
                name: '选品',
                meta: {
                    authRule: ['low_price_mall/developer_low_price_mall_cost_analysis']
                },
                noDropdown: false,
                component: adminRouter,
                children:[
                    {
                        path: 'ignoreList',
                        name: '忽略列表',
                        component: () => import('@/views/lowPriceMall/ignoreList.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_disregarded_list']
                        }
                    },
                    {
                        path: 'caiGouIndex',
                        name: '选品列表',
                        component: () => import('@/views/lowPriceMall/caiGouIndex.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_developer_analysis_list']
                        }
                    },
                    {
                        path: 'caiGouInPurchasingLowPrice',
                        name: '采购中列表',
                        component: () => import('@/views/lowPriceMall/caiGouInPurchasingLowPrice.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_developer_purchase_list']
                        }
                    },
                    {
                        path: 'caiGouPurchaseCompletedLowPrice',
                        name: '采购完成列表',
                        component: () => import('@/views/lowPriceMall/caiGouPurchaseCompletedLowPrice.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_developer_purchase_finish_list']
                        }
                    },
                ]
            },
            // 采购-选品
            {
                path: '/lowPriceMall/operate',
                name: '运营',
                meta: {
                    authRule: ['low_price_mall/operator_low_price_mall_cost_analysis']
                },
                noDropdown: false,
                component: adminRouter,
                children:[
                    {
                        path: 'lowPriceUndistributed',
                        name: '未分配列表',
                        component: () => import('@/views/lowPriceMall/lowPriceUndistributed.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_operator/wait_operation_list']
                        }
                    },
                    {
                        path: 'lowPriceWaitOperated',
                        name: '待运营列表',
                        component: () => import('@/views/lowPriceMall/lowPriceWaitOperated.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_operator/wait_operation_list']
                        }
                    },
                    {
                        path: 'lowPriceInOperation',
                        name: '运营中列表',
                        component: () => import('@/views/lowPriceMall/lowPriceInOperation.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_operator/wait_operation_list']
                        }
                    },
                    {
                        path: 'lowPriceNoOperated',
                        name: '不再运营列表',
                        component: () => import('@/views/lowPriceMall/lowPriceNoOperated.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_operator/wait_operation_list']
                        }
                    },
                ]
            },
            {
                path: '/lowPriceMall/realTimeOperate',
                name: '实时运营',
                meta: {
                    // authRule: ['low_price_mall/operator_low_price_mall_cost_analysis']
                },
                noDropdown: false,
                component: adminRouter,
                children:[
                    {
                        path: 'lowPriceRealTimeOperateAdmin',
                        name: 'Asin运营列表',
                        component: () => import('@/views/lowPriceMall/realTime/lowPriceRealTimeOperateAdmin.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_operating/operating_asin_list']
                        }
                    },
                    {
                        path: 'lowPriceNoRealTimeOperateAdmin',
                        name: 'Asin不再运营列表',
                        component: () => import('@/views/lowPriceMall/realTime/lowPriceNoRealTimeOperateAdmin.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_operating/no_operating_asin_list']
                        }
                    },
                    {
                        path: 'lowPriceRealTimeOperate',
                        name: 'Asin运营列表',
                        component: () => import('@/views/lowPriceMall/realTime/lowPriceRealTimeOperate.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_operating/personal_operating_asin_list']
                        }
                    },
                    {
                        path: 'lowPriceNoRealTimeOperate',
                        name: 'Asin不再运营列表',
                        component: () => import('@/views/lowPriceMall/realTime/lowPriceNoRealTimeOperate.vue'),
                        meta: {
                            authRule: ['admin/low_price_mall/low_price_mall_operating/personal_no_operating_asin_list']
                        }
                    },

                ]
            }
        ]
    },
    {
        path: '/basicConfigurationData',
        component: Home,
        redirect: '/categoryList/basicConfigurationData',
        icon: 'wxbzhanghu',
        name: '基础配置数据',
        meta: {
            authRule: ['admin/manager/index/get_cost_control_message']
        },
        noDropdown: true,
        children: [{
            path: 'index',
            name: '基础配置数据',
            component: () => import('@/views/categoryList/basicConfigurationData.vue')
        }]
    },
    {
        path: '/teambition',
        component: Home,
        icon: 'wxbzhanghu',
        name: 'Teambition',
        children: [
            {
                path: 'operator_lists',
                name: 'Teambition提醒',
                component: () => import('@/views/teambition/operatorRemindList.vue'),
                meta: {
                    authRule: ['admin/teambition/remind/operator_lists']
                }
            },
            {
                path: 'manager_lists',
                name: 'Teambition提醒',
                component: () => import('@/views/teambition/managerRemindList.vue'),
                meta: {
                    authRule: ['admin/teambition/remind/manager_lists']
                }
            }
        ]
    },
    {
        path: '/leadingStar',
        component: Home,
        redirect: '/leadingStar/index',
        icon: 'wxbzhanghu',
        name: '领星',
        meta: {
            authRule: ['lingxing']
        },
        noDropdown: false,
        children: [{
            path: 'index',
            name: '店铺',
            component: () => import('@/views/leadingStar/index.vue'),
            meta: {
                authRule: ['lingxing/shoplist']
            }
        }]
    },
    // {
    //     path: '/rootCategory',
    //     component: Home,
    //     redirect: '/rootCategory/index',
    //     icon: 'wxbzhanghu',
    //     name: '根类目',
    //     meta: {
    //         authRule: ['root_category']
    //     },
    //     noDropdown: true,
    //     children: [{
    //         path: "index",
    //         name: "根类目",
    //         component: () => import("@/views/rootCategory/index.vue")
    //     }]
    // },
    // {
    //     path: '/basicLibrary',
    //     component: Home,
    //     redirect: '/basicLibrary/index',
    //     icon: 'wxbzhanghu',
    //     name: '基础库',
    //     meta: {
    //         authRule: ['basic_warehouse']
    //     },
    //     noDropdown: true,
    //     children: [{
    //         path: "index",
    //         name: "基础库",
    //         component: () => import("@/views/basicLibrary/index.vue")
    //     }]
    // },
    // {
    //     path: '/reference',
    //     component: Home,
    //     redirect: '/reference/index',
    //     icon: 'wxbzhanghu',
    //     name: '参考库',
    //     meta: {
    //         authRule: ['reference']
    //     },
    //     noDropdown: true,
    //     children: [{
    //         path: 'index',
    //         name: '基础库',
    //         component: () => import('@/views/reference/index.vue')
    //     }]
    // },
    {
        path: '/warehouse',
        component: Home,
        redirect: '/warehouse/manager',
        icon: 'wxbzhanghu',
        name: '选品采购',
        meta: {
            authRule: ['branch_warehouse']
        },
        children: [
            // {
            //     path: 'adminLoadingList',
            //     name: '更新中列表',
            //     component: () => import('@/views/warehouse/adminLoadingList.vue'),
            //     meta: {
            //         authRule: ['admin/cost_analysis/assigned_selection/assigned_updating_list']
            //     }
            // },
            {
                path: 'firstAuditList',
                name: '一审列表',
                component: () => import('@/views/costAnalysis/firstAuditList.vue'),
                meta: {
                    authRule: ['admin/cost_analysis/personal/audit_list']
                },
            },
            {
                path: 'parsingList',
                name: '解析中列表',
                component: () => import('@/views/warehouse/parsingList.vue'),
                // meta: {
                //     authRule: ['admin/cost_analysis/batch_self_build/cost_analysis_updating_list']
                // }
            },

            {
                path: 'myChoiceTransfer',
                name: '我的选品(转移)',
                component: () => import('@/views/costAnalysis/myChoiceTransfer.vue'),
                meta: {
                    authRule: ['admin/cost_analysis/transfer/transfer_analysis_list']
                },
            },
            {
                path: 'inPurchaseTransfer',
                name: '采购中列表(转移)',
                component: () => import('@/views/costAnalysis/inPurchaseTransfer.vue'),
                meta: {
                    authRule: ['admin/cost_analysis/transfer/transfer_purchase_list']
                },
            },
            {
                path: 'ignoreList',
                name: '忽略列表',
                component: () => import('@/views/costAnalysis/ignoreList.vue'),
                meta: {
                    authRule: ['admin/cost_analysis/personal/disregarded_list']
                },
            },
            {
                path: 'myChoice',
                name: '我的选品',
                component: () => import('@/views/costAnalysis/myChoice.vue'),
                meta: {
                    authRule: ['admin/cost_analysis/personal/analysis_list']
                },
            },
            {
                path: 'inPurchase',
                name: '采购中列表',
                component: () => import('@/views/costAnalysis/inPurchase.vue'),
                meta: {
                    authRule: ['admin/cost_analysis/personal/purchase_list']
                },
            },
            {
                path: 'purchaseCompleted',
                name: '采购完成列表',
                component: () => import('@/views/costAnalysis/purchaseCompleted.vue'),
                meta: {
                    authRule: ['admin/cost_analysis/personal/purchase_finish_list']
                },
            },
        ]
    },
    // {
    //     path: '/selfBuiltLibrary',
    //     component: Home,
    //     redirect: '/selfBuiltLibrary/index',
    //     icon: 'wxbzhanghu',
    //     name: '自建选库',
    //     meta: {
    //         authRule: ['admin/manager/build_selection']
    //     },
    //     noDropdown: true,
    //     children: [{
    //         path: 'index',
    //         name: '自建选库',
    //         component: () => import('@/views/selfBuiltLibrary/index.vue')
    //     }]
    // },
    {
        path: '/costAnalysisOne',
        component: Home,
        redirect: '/costAnalysisOne/purchaserList',
        icon: 'wxbzhanghu',
        name: '成本分析',
        meta: {
            authRule: ['admin/manager/cost_analysis']
        },
        children: [
            // {
            //     path: 'undistributed',
            //     name: '自建未分配列表',
            //     component: () => import('@/views/costAnalysisOne/undistributed.vue'),
            //     meta: {
            //         authRule: ['admin/manager/cost_analysis/manager_undistributed_self_build_list']
            //     }
            // },
            {
                path: 'purchasegnoreList',
                name: '采购人员忽略列表',
                component: () => import('@/views/costAnalysisOne/purchasegnoreList.vue'),
                meta: {
                    authRule: ['admin/manager/cost_analysis/manager_disregarded_list']
                }
            },
            {
                path: 'purchaserList',
                name: '采购人员选品列表',
                component: () => import('@/views/costAnalysisOne/purchaserList.vue'),
                meta: {
                    authRule: ['admin/manager/cost_analysis/manager_analysis_list']
                }
            },
            {
                path: 'BuyingList',
                name: '采购人员采购中列表',
                component: () => import('@/views/costAnalysisOne/BuyingList.vue'),
                meta: {
                    authRule: ['admin/manager/cost_analysis/manager_purchase_list']
                }
            },
            {
                path: 'BuyFinishList',
                name: '采购人员采购完成列表',
                component: () => import('@/views/costAnalysisOne/BuyFinishList.vue'),
                meta: {
                    authRule: ['admin/manager/cost_analysis/manager_purchase_finish_list']
                }
            },
            {
                path: 'noConformingProfitList',
                name: '采购完成不符利润列表',
                component: () => import('@/views/costAnalysisOne/noConformingProfitList.vue'),
                meta: {
                    authRule: ['admin/manager/cost_analysis/manager_operational_and_profitable_list']
                }
            },
            {
                path: 'auditDetails',
                name: '审核详情',
                component: () => import('@/views/costAnalysisOne/auditDetails.vue'),
                meta: {
                    authRule: ['admin/manager/cost_analysis/audit_review_list']
                }
            },
        ]
    },
    {
        path: '/linkProduction',
        component: Home,
        icon: 'wxbzhanghu',
        redirect: '/linkProduction/activeListTransfer',
        name: '链接制作',
        meta: {
            authRule: ['link_production/producer']
        },
        children: [
            {
                path: 'wait',
                name: '待制作链接',
                component: () => import('@/views/linkProduction/wait.vue'),
                meta: {
                    authRule: ['admin/link_production/producer/waiting_production_list']
                },
            },
            {
                path: 'personal',
                name: '我的待制作链接',
                component: () => import('@/views/linkProduction/personal.vue'),
                meta: {
                    authRule: ['admin/link_production/producer/personal_production_list']
                },
            },
            {
                path: 'personalWait',
                name: '我的待分配链接',
                component: () => import('@/views/linkProduction/personalWait.vue'),
                meta: {
                    authRule: ['admin/link_production/producer/personal_waiting_allocate_production_list']
                },
            },
            {
                path: 'personalFinish',
                name: '我的完成分配链接',
                component: () => import('@/views/linkProduction/personalFinish.vue'),
                meta: {
                    authRule: ['admin/link_production/producer/personal_finish_allocate_production_list']
                },
            }
        ]
    },
    {
        path: '/adminLinkProduction',
        component: Home,
        icon: 'wxbzhanghu',
        redirect: '/linkProduction/activeListTransfer',
        name: '链接制作',
        meta: {
            authRule: ['link_production/manager']
        },
        children: [
            {
                path: 'adminWait',
                name: '未分配链接列表',
                component: () => import('@/views/adminLinkProduction/adminWait.vue'),
                meta: {
                    authRule: ['admin/link_production/manager/manager_waiting_production_list']
                },
            },
            {
                path: 'adminPersonal',
                name: '待制作链接列表',
                component: () => import('@/views/adminLinkProduction/adminPersonal.vue'),
                meta: {
                    authRule: ['admin/link_production/manager/manager_assigned_production_list']
                },
            },
            {
                path: 'adminPersonalWait',
                name: '待分配运营链接列表',
                component: () => import('@/views/adminLinkProduction/adminPersonalWait.vue'),
                meta: {
                    authRule: ['admin/link_production/manager/manager_waiting_allocate_production_list']
                },
            },
            {
                path: 'adminPersonalFinish',
                name: '已分配运营链接列表',
                component: () => import('@/views/adminLinkProduction/adminPersonalFinish.vue'),
                meta: {
                    authRule: ['admin/link_production/manager/manager_finish_allocate_production_list']
                },
            }
        ]
    },
    {
        path: '/operationalSelection',
        component: Home,
        icon: 'wxbzhanghu',
        redirect: '/operationalSelection/activeListTransfer',
        name: '选品运营',
        meta: {
            authRule: ['operation']
        },
        children: [
            {
                path: 'activeListTransfer',
                name: '运营中列表(转移)',
                component: () => import('@/views/operationalSelection/activeListTransfer.vue'),
                meta: {
                    authRule: ['admin/operation/index/update_operation_status_to_running']
                },
            },
            {
                path: 'unallocated',
                name: '未分配列表',
                component: () => import('@/views/operationalSelection/unallocated.vue'),
                meta: {
                    authRule: ['admin/operation/index/undistributed_list']
                },
            },
            {
                path: 'myChoice',
                name: '我的选品',
                component: () => import('@/views/operationalSelection/myChoice.vue'),
                meta: {
                    authRule: ['admin/operation/index/assigned_list']
                },
            },
            {
                path: 'activeList',
                name: '运营中列表',
                component: () => import('@/views/operationalSelection/activeList.vue'),
                meta: {
                    authRule: ['admin/operation/index/update_operation_status_to_running']
                },
            },
            {
                path: 'noOperationalList',
                name: '不再运营列表',
                component: () => import('@/views/operationalSelection/noOperationalList.vue'),
                meta: {
                    authRule: ['admin/operation/index/update_operation_status_to_fail']
                },
            },
        ]
    },
    {
        path: '/operationManagement',
        component: Home,
        redirect: '/operationManagement/operatingList',
        icon: 'wxbzhanghu',
        name: '运营管理',
        meta: {
            authRule: ['operating_asin_manager']
        },
        children: [
            {
                path: 'operatingManage',
                name: '运营列表',
                component: () => import('@/views/operationManagement/operatingManage.vue'),
                meta: {
                    authRule: ['admin/operating_asin_manager/index/personal_operating_asin_list']
                }
            },
            {
                path: 'operatingList',
                name: '运营列表',
                component: () => import('@/views/operationManagement/operatingList.vue'),
                meta: {
                    authRule: ['admin/operating_asin_manager/index/operating_asin_list']
                }
            },
            {
                path: 'noOperatingManage',
                name: '不再运营列表',
                component: () => import('@/views/operationManagement/noOperatingManage.vue'),
                meta: {
                    authRule: ['admin/operating_asin_manager/index/nolonger_operating_asin_list']
                }
            },
            {
                path: 'noOperatingList',
                name: '不再运营列表',
                component: () => import('@/views/operationManagement/noOperatingList.vue'),
                meta: {
                    authRule: ['admin/operating_asin_manager/index/personal_nolonger_operating_asin_list']
                }
            },
            // {
            //     path: 'operationalUpload',
            //     name: '实时运营上传',
            //     component: () => import('@/views/operationManagement/operationalUpload.vue'),
            //     meta: {
            //         authRule: ['operating_asin_manager/upload']
            //     }
            // },
            // {
            //     path: 'costAndFreightUpload',
            //     name: '成本运费上传',
            //     component: () => import('@/views/operationManagement/costAndFreightUpload.vue'),
            //     meta: {
            //         authRule: ['operating_asin_manager/init_price']
            //     }
            // },
            // {
            //     path: 'packageSpecificationsUpload',
            //     name: '包装规格上传',
            //     component: () => import('@/views/operationManagement/packageSpecificationsUpload.vue'),
            //     meta: {
            //         authRule: ['operating_asin_manager/specification']
            //     }
            // },
        ]
    },
    {
        path: '/crewSelection',
        component: Home,
        icon: 'wxbzhanghu',
        redirect: '/crewSelection/crewSelectionPurchase',
        name: '组员选品',
        meta: {
            authRule: ['admin/group/index/ui']
        },
        children: [
            {
                path: 'crewSelectionPurchase',
                name: '组员选品采购',
                component: () => import('@/views/crewSelection/crewSelectionPurchase.vue'),
                meta: {
                    authRule: ['admin/group/index/get_purchase_list']
                },
            },
            {
                path: 'crewSelectionOperate',
                name: '组员选品运营',
                component: () => import('@/views/crewSelection/crewSelectionOperate.vue'),
                meta: {
                    authRule: ['admin/group/index/get_operation_list']
                },
            }
        ]
    },
    {
        path: '/individualStatistics',
        component: Home,
        icon: 'wxbzhanghu',
        redirect: '/individualStatistics/selectionStatistics',
        name: '个人统计',
        meta: {
            authRule: ['admin/personal_statistics']
        },
        children: [
            {
                path: 'selectionStatistics',
                name: '选品统计',
                component: () => import('@/views/individualStatistics/selectionStatistics.vue'),
                meta: {
                    authRule: ['admin/cost_analysis/statistics/statistics_developer']
                },
            },
            // {
            //     path: 'administratorStatistics',
            //     name: '管理员分库统计',
            //     component: () => import('@/views/individualStatistics/administratorStatistics.vue'),
            //     meta: {
            //         authRule: ['admin/cost_analysis/statistics/statistics_manager_selection']
            //     },
            // },
            {
                path: 'operationalStatistics',
                name: '个人运营统计',
                component: () => import('@/views/operationalSelection/operationalStatistics.vue'),
                meta: {
                    authRule: ['admin/operation/index/personal_statistics_operator']
                },
            },
        ]
    },


    {
        path: '/productStatistics',
        component: Home,
        redirect: '/productStatistics/categoryStatistics',
        icon: 'wxbzhanghu',
        name: '产品统计',
        meta: {
            authRule: ['statistics']
        },
        children: [
            {
                path: 'categoryStatistics',
                name: '类目统计',
                component: () => import('@/views/productStatistics/categoryStatistics.vue'),
                meta: {
                    authRule: ['admin/manager/statistics/statistics_category']
                }
            },
            // {
            //     path: 'personnelStatistics',
            //     name: '管理员分库统计',
            //     component: () => import('@/views/productStatistics/personnelStatistics.vue'),
            //     meta: {
            //         authRule: ['admin/manager/statistics/statistics_manager_selection']
            //     }
            // },
            {
                path: 'selectionStatistics',
                name: '选品统计',
                component: () => import('@/views/productStatistics/selectionStatistics.vue'),
                meta: {
                    authRule: ['admin/manager/statistics/statistics_developer']
                }
            },
            {
                path: 'operationalStatistics',
                name: '运营统计',
                component: () => import('@/views/productStatistics/operationalStatistics.vue'),
                meta: {
                    authRule: ['admin/manager/statistics/statistics_operator']
                }
            },
            {
                path: 'linkProductionStatistics',
                name: '链接制作统计',
                component: () => import('@/views/productStatistics/linkProductionStatistics.vue'),
                meta: {
                    authRule: ['admin/manager/statistics/statistics_producer']
                }
            },
            {
                path: 'weekKPI',
                name: '周KPI统计',
                component: () => import('@/views/productStatistics/weekKPI.vue'),
                meta: {
                    authRule: ['admin/manager/statistics/statistics_operator']
                }
            },
            {
                path: 'monthKPI',
                name: '月KPI统计',
                component: () => import('@/views/productStatistics/monthKPI.vue'),
                meta: {
                    authRule: ['admin/manager/statistics/statistics_operator']
                }
            },
            {
                path: 'categoryStatusStatistics',
                name: '类目状态流统计',
                component: () => import('@/views/productStatistics/categoryStatusStatistics.vue'),
                meta: {
                    authRule: ['admin/manager/statistics/statistics_kpi_teambition_category']
                }
            },
            {
                path: 'operationStatusStatistics',
                name: '运营状态流统计',
                component: () => import('@/views/productStatistics/operationStatusStatistics.vue'),
                meta: {
                    authRule: ['admin/manager/statistics/statistics_kpi_teambition_operator']
                }
            },
            {
                path: 'operationSalesStatistics',
                name: '运营销量统计',
                component: () => import('@/views/productStatistics/operationSalesStatistics.vue'),
                meta: {
                }
            },
        ]
    },
    {
        path: '/shipmentLogistics',
        component: Home,
        redirect: '/shipmentLogistics/shipmentLogistics',
        icon: 'wxbzhanghu',
        name: '物流与发票',
        meta: {
            authRule: ['logistics_invoice']
        },
        children: [
            {
                path: 'shipmentLogistics',
                name: '物流-货件导入',
                component: () => import('@/views/shipmentLogistics/index.vue')
            },
            {
                path: 'invoiceAddress',
                name: '物流-地址',
                component: () => import('@/views/invoiceAddress/index.vue')
            },
            {
                path: 'invoiceAsin',
                name: '物流-Asin',
                component: () => import('@/views/invoiceAsin/index.vue')
            },
            {
                path: 'lgisticsInvoice',
                name: '物流-发票生成',
                component: () => import('@/views/lgisticsInvoice/index.vue')
            }
        ]
    },

    {
        path: '/extraTool',
        component: Home,
        redirect: '/extraTool/distributionCostCalculation',
        icon: 'wxbzhanghu',
        name: '工具',
        meta: {
            authRule: ['extra_tool']
        },
        children: [
            {
                path: 'distributionCostCalculation',
                name: '仓储费计算',
                component: () => import('@/views/extraTool/distributionCostCalculation.vue'),
                meta: {
                    authRule: ['delivery_charge_calculator']
                }
            },
            {
                path: 'asinQuery',
                name: '已处理sin查询',
                component: () => import('@/views/extraTool/asinQuery.vue'),
                meta: {
                    authRule: ['dealt_asin_query']
                }
            },
            {
                path: 'asinSpecification',
                name: '运营Asin规格',
                component: () => import('@/views/extraTool/asinSpecification.vue'),
                meta: {
                    authRule: ['dealt_asin_query']
                }
            },
            {
                path: 'asinAttribute',
                name: '竞品Asin属性',
                component: () => import('@/views/extraTool/asinAttribute.vue'),
                meta: {
                    authRule: ['competing_asin_attribute']
                }
            },
            {
                path: 'asinTrafficComparison',
                name: 'Asin流量对比',
                component: () => import('@/views/asinTrafficComparison/index.vue'),
                meta: {
                    // authRule: ['/admin/extra/asin_traffic_comparison/index']
                }
            },
            {
                path: 'bestsellerRankAsins',
                name: '类目畅销排行',
                component: () => import('@/views/extraTool/bestsellerRankAsins.vue')
            },

        ]
    },
    {
        path: '/administratorAnalysis',
        component: Home,
        redirect: '/administratorAnalysis/index',
        icon: 'wxbzhanghu',
        name: '管理员分析',
        meta: {
            authRule: ['admin/master/index/manager_lists']
        },
        noDropdown: true,
        children: [{
            path: 'index',
            name: '管理员分析',
            component: () => import('@/views/administratorAnalysis/index.vue')
        }]
    },
]

export default router
